import React from "react";
import RegularTaskManager from "./RegularTaskManager";

export default function RegularTaskNormal() {
  return <RegularTaskManager variant="NORMAL" />;
}
